<template>
  <div>

    <div>
      <el-table
        border
        stripe
        resizable
        :data="listData"
        style="width: 100%"
        size="small"
        :key="pagekey"
        :header-cell-style="{ background: '#f2f3f5' }"
      >
        <el-table-column
          label="费用类型"
          prop="Title"
          width="180"
        >
          <template slot-scope="scope">
            <span
              style="font-size:16px"
              :style="scope.row.Title == '合计' ? 'font-weight:600' : ''"
            >{{ scope.row.Title }} {{ scope.row.Title == '合计' ? '(￥)' : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="运费金额"
          align="right"
          prop="BaseVal"
          width="180"
        >
          <template slot-scope="scope">

            <el-statistic
              group-separator=","
              :precision="2"
              :value="scope.row['BaseVal']"
              class="el-statistic-freight"
              style="text-align: right"
            ></el-statistic>
          </template>
        </el-table-column>

        <el-table-column
          v-if="lirun"
          label="利润率（%）"
          align="right"
          width="160"
          prop="LirunVal"
        > </el-table-column>
        <el-table-column
          v-if="shuilv"
          label="税率（%）"
          align="right"
          width="160"
          prop="RateVal"
        > </el-table-column>
        <el-table-column
          v-if="shuilv || lirun"
          label="实际金额（含税/含利润）"
          align="right"
          width="180"
          prop="Val"
        >
          <template slot-scope="scope">
            <el-statistic
              group-separator=","
              :precision="2"
              :value="scope.row['Val']"
              class="el-statistic-freight"
              style="text-align: right"
            ></el-statistic>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>
<script>
import { getResultDetail } from '@/modules/contract/api/freightnew.js'
export default {
  name: 'FreightResultPage',
  components: {},
  props: {
    bform: {
      type: Object,
      default: () => {
        return null
      }
    },
  },
  data () {
    return {
      MakeReportId: '',
      issubmit: false,
      freightlist: [],
      allfreight: 0,
      pagekey: 0,
      baseinfo: null,
      showAdd: false,
      form: null,
      form2: null,
      formRules: {
        title: [
          { required: true, message: '请输入费用名称', trigger: ['blur', 'change'] }
        ],
      },
      lirun: false,
      shuilv: false,
      isedit: false
    }

  },
  computed: {},
  mounted () {
    if (this.bform) {
      this.MakeReportId = this.bform.Id
      this.loadPageData()
    }
  },
  methods: {
    loadPageData () {
      getResultDetail({ Id: this.MakeReportId }).then(res => {
        if (res.data.Data) {
          this.baseinfo = res.data.Data
          if (res.data.Data.detail) {
            this.form = res.data.Data.detail
            if (this.form.ComAttrJson) {
              this.listData = JSON.parse(res.data.Data.detail.ComAttrJson)
            }
            if (this.form.OtherAttrJson) {
              JSON.parse(res.data.Data.detail.OtherAttrJson).map(p => {
                this.listData.push(p)
              })
            }
            if (res.data.Data.detail.ConfigAttrJson) {
              let config = JSON.parse(res.data.Data.detail.ConfigAttrJson)
              console.log(config, 'config')
              this.lirun = config.SetLirun * 1 == 1
              this.shuilv = config.SetShuilv * 1 == 1
            }
            this.getall()
          }
        }
      })
    },

    getall () {
      let all = 0, all2 = 0;
      this.listData.filter(p => { return p.Title != '合计' }).map(p => {
        all += p.BaseVal * 1
        all2 += p.Val * 1

      })
      let hindex = this.listData.findIndex(p => { return p.Title == '合计' })
      if (hindex == -1) {
        this.listData.push({
          Title: '合计',
          BaseVal: all,
          Val: all2,
        })
      } else {
        this.listData[hindex].BaseVal = all
        this.listData[hindex].Val = all2
      }
      this.pagekey++
    },
  }
}
</script>


<style>
.freight-title{
  text-align: right;
}
.freight-content{
  text-align: right;
}
.el-statistic-freight .con{
 justify-content: end !important;
}
</style>